
import convertUnit from '@/utils/convertUnit';
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component
export default class RigInfo extends Vue {
    // @Prop({default: () =>{return {name: 'Abrua'}}})
    // public rig!: any;

    rating:any = convertUnit(this.rig.minimumHPRating.value, this.currentUnitSystem, this.rig.unitSystem.toLowerCase() === 'field' ? 'hp' : 'W')
    minimumDrillDepth:any = convertUnit(this.rig.minimumDrillDepth.value, this.currentUnitSystem, this.rig.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')

    get ratings () {
        return this.rating
    }

    get minimumDrillDepths () {
        return this.minimumDrillDepth
    }

    set ratings (rate) {
        this.rating = convertUnit(this.rig.minimumHPRating.value, this.currentUnitSystem, this.rig.unitSystem.toLowerCase() === 'field' ? 'hp' : 'W')
        // this.rating = this.rig.minimumHPRating.value;
    }

    set minimumDrillDepths (rate) {
        this.minimumDrillDepth = convertUnit(this.rig.minimumDrillDepth.value, this.currentUnitSystem, this.rig.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
    }

    takeRightPane() {
        return this.$store.commit('setRightPaneToFalse');
    }

    @Watch('rig')
    onrateateChanged(newVal:any){
        this.rating = convertUnit(newVal.minimumHPRating.value, this.currentUnitSystem, newVal.unitSystem.toLowerCase() === 'field' ? 'hp' : 'W')
        this.minimumDrillDepth = convertUnit(newVal.minimumDrillDepth.value, this.currentUnitSystem, newVal.unitSystem.toLowerCase() === 'field' ? 'ft' : 'm')
    }

    get rig () {
        return this.$store.getters['getCurrentRig']
    }

    get currentUnitSystem(){
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }
}
